module.exports = __webpack_public_path__ + "img/video_expand.2c7ca566.png";